










import { Vue, Component } from "vue-property-decorator";
import { IState } from "@/store";
import { IUser } from "@/models/users";
import { mapState } from "vuex";

@Component({
  computed: {
    ...mapState({
      user: (state: IState) => state.user
    })
  }
})
export default class TwoFactorAuthForm extends Vue {
  private user!: IUser;

  public get hasEnabled2fa() {
    return this.user.enabled_2fa;
  }

  public get message() {
    return this.hasEnabled2fa
      ? "_sentence.2fa_enabled"
      : "_sentence.2fa_disabled";
  }

  public get cta() {
    return this.hasEnabled2fa ? "_action.disable" : "_action.enable";
  }

  public show2faModal() {
    this.$store.dispatch("ui/open/windowModal", {
      config: {
        width: 620,
        component: () => import("./configure2faModal.vue")
      }
    });
  }
}
